/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "reel_colors_default": "",
  "reel_size_default": "text-hn-headline-sm [&_span]:before:mx-1",
  "reel_variant_default": "uppercase italic animate-loop [&_span]:before:content-[\"•\"]",
  "colors_default": "",
  "size_default": "py-1.5",
  "variant_default": "flex flex-row flex-nowrap overflow-hidden whitespace-nowrap italic uppercase",
  "reel_colors_alternative": "",
  "reel_size_alternative": "text-hn-headline-2xs container-col-sm-8:text-hn-headline-xs md:text-hn-headline-sm [&_span]:before:mx-1",
  "reel_variant_alternative": "uppercase italic animate-loop [&_span]:before:content-[\"•\"]",
  "colors_alternative": "text-white [text-shadow:1px_2px_0_black]",
  "size_alternative": "",
  "variant_alternative": "flex flex-row flex-nowrap overflow-hidden whitespace-nowrap italic uppercase"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "LoopAround");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;